import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const FolderBusinessEntityListCmp_FolderBusinessEntity_Fragment =
  graphql(`
    fragment FolderBusinessEntityListCmp_FolderBusinessEntity_Fragment on FolderBusinessEntity {
      __typename
      _id

      color
      stateId
      isConfidential
      businessCreationDate

      consolidation {
        quotationReceiverActors {
          thirdPartyId
          categoryIds
          __typename
          thirdParty {
            ...FolderBusinessEntityListCmp_ThirdParty_Fragment
          }
        }
        internalActors {
          thirdPartyId
          categoryIds
          __typename
          thirdParty {
            ...FolderBusinessEntityListCmp_ThirdParty_Fragment
          }
        }
        quotationEmitterActors {
          thirdPartyId
          categoryIds
          __typename
          thirdParty {
            ...FolderBusinessEntityListCmp_ThirdParty_Fragment
          }
        }
        address {
          ...AddressCardCmp_Address_Fragment
        }
        title
        description
        externalActors {
          thirdPartyId
          categoryIds
          __typename
          thirdParty {
            ...FolderBusinessEntityListCmp_ThirdParty_Fragment
          }
          ... on ActorOrganization {
            references {
              value
            }
          }
          ... on ActorPerson {
            references {
              value
            }
          }
        }
      }

      ... on Folder {
        code
        archiveInfo {
          startDateForAnalytics
          endDateForAnalytics
        }
      }

      ... on Mission {
        folderId
        kind
        compositeMissionId
        subMissions {
          _id
          code
          compositeMissionId
          folderId
          stateId
          consolidation {
            title
          }
        }
        categoryParentId
        categoryLeaf
        type {
          _id
          code
          label
        }
        code
        archiveInfo {
          startDateForAnalytics
          endDateForAnalytics
        }
      }
    }
  `);

export type FolderBusinessEntityListCmp_FolderBusinessEntity = ResultOf<
  typeof FolderBusinessEntityListCmp_FolderBusinessEntity_Fragment
>;
